import { render, staticRenderFns } from "./Reception.vue?vue&type=template&id=51054407"
import script from "./Reception.vue?vue&type=script&lang=js"
export * from "./Reception.vue?vue&type=script&lang=js"
import style0 from "./Reception.vue?vue&type=style&index=0&id=51054407&prod&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports